


























import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class NoResults extends Vue {
  @Prop({ type: String, default: '' })
  public message!: string;

  @Prop({ type: Boolean, default: false })
  public isSearch!: boolean;

  @Prop({ type: Boolean, default: false })
  public isHappy!: boolean;

  @Prop({ type: Boolean, default: false })
  public centralizeAbsolute!: boolean;

  get showMessage(): boolean {
    return this.message.length > 0;
  }

  hasCustomMessageSlot() {
    return !!this.$slots.customMessage;
  }
}
